import CryptoJS from "crypto-js";
import { useState, useEffect } from "react";
const { VITE_KEY } = import.meta.env;

export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value]);

    return debouncedValue;
};

export const debounceFunc = (func, delay) => {
    let timerId;
    return (...args) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => func(...args), delay);
    };
};

export const useClickOutside = (val, ref, cb, extraExcludes = []) => {
    const handleClick = (e) => {
        //чтоб при клике на тост, куки не вырубалась модалка
        const excludes = [".p-toast", ".cookies", ...extraExcludes];
        for (let i = 0; i < excludes.length; i++) {
            const cl = excludes[i];
            const el = document.querySelector(cl);

            if (el && el.contains(e.target)) return;
        }
        //чтоб при клике на тост, куки не вырубалась модалка

        if (ref.current && !ref.current.contains(e.target)) {
            cb();
        }
    };

    useEffect(() => {
        if (val) {
            document.addEventListener("click", handleClick, { capture: true });
        } else {
            document.removeEventListener("click", handleClick, { capture: true });
        }

        return () => {
            document.removeEventListener("click", handleClick, { capture: true });
        };
    });
};

export const useGetHeightToScrollContainer = (id, cb) => {
    useEffect(() => {
        resizeFunc();
        window.addEventListener("resize", resizeFunc);

        return () => window.removeEventListener("resize", resizeFunc);
    }, []);

    const resizeFunc = () => {
        const mainContainer = document.getElementById("offset-container");
        const elem = document.getElementById(id);
        if (elem && mainContainer) cb(mainContainer.clientHeight + mainContainer.offsetTop - elem.getBoundingClientRect().top);
    };
};

export const useHandleResize = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 820);
    };

    return isMobile;
};

export const useInViewport = (elems = [], cb, isStart) => {
    useEffect(() => {
        if (isStart) return;

        const debouncedScrollHandler = debounceFunc(scrollHandler, 2000);

        setTimeout(() => {
            debouncedScrollHandler();
            document.addEventListener("scroll", debouncedScrollHandler);

            return () => {
                document.removeEventListener("scroll", debouncedScrollHandler);
            };
        }, 40);
    }, [isStart]);

    let tmpArr = [];

    const scrollHandler = (e) => {
        const screenHeight = document.documentElement.clientHeight;
        const nodeArr = elems
            .reduce((acc, row) => {
                const node = document.querySelectorAll(row);
                acc.push([...node]);
                return acc;
            }, [])
            .flat();

        nodeArr.forEach((node) => {
            const rect = node.getBoundingClientRect();
            if (rect.top >= 0 && rect.bottom <= screenHeight) {
                if (!tmpArr.some((s) => s.text == node.id)) {
                    cb(node);
                    tmpArr.push({ node, text: node.id });
                }
            } else {
                tmpArr = tmpArr.filter((f) => f.text !== node.id);
            }
        });
    };
};

export const useCrypto = () => {
    const secretKey = VITE_KEY;
    const encryptData = (data) => {
        const jsonString = JSON.stringify(data);
        return CryptoJS.AES.encrypt(jsonString, secretKey).toString();
    };

    const decryptData = (encryptedData) => {
        try {
            const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
            const decryptedJsonString = decryptedBytes.toString(CryptoJS.enc.Utf8);
            return JSON.parse(decryptedJsonString);
        } catch (error) {
            console.error("Ошибка при расшифровке:", error.message);
            throw error;
        }
    };

    return { encryptData, decryptData };
};
